export default __webpack_public_path__ + "static/media/2-1_arrowcircleleft.c9dc9e97.svg";